import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { PurchaseButton } from "./PurchaseButton";
import { offer } from "../data/offer";
export function GuaranteeSection() {
  return <section className="bg-canvas" data-id="element-94" data-mp="9umh8ubc1s8c">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-95" data-mp="9tbhr6ox76n1">
        <div className="grid items-center gap-10 rounded-[2rem] bg-white p-8 shadow-[0_14px_40px_-24px_rgba(11,24,56,0.35)] md:grid-cols-[auto_1fr] md:p-12" data-id="element-96" data-mp="et66b3l83k4x">
          <div role="img" aria-label="7-Day Money-Back Guarantee seal" className="mx-auto flex h-52 w-52 items-center justify-center rounded-full bg-gold ring-[6px] ring-gold-light" data-id="element-97" data-mp="jsadjool77sm">
            <div className="flex h-[88%] w-[88%] flex-col items-center justify-center rounded-full border-2 border-dashed border-navy/40 text-center text-navy" data-id="element-98" data-mp="sm5ml7stxidj">
              <ShieldCheckIcon className="h-8 w-8" strokeWidth={2.25} aria-hidden="true" data-id="element-99" data-mp="12jk0azndbt25" />
              <span className="mt-1 font-display text-4xl font-extrabold leading-none" data-id="element-100" data-mp="17hv9d85u9zjb">7-Day</span>
              <span className="mt-1.5 px-4 font-display text-[11px] font-extrabold uppercase leading-tight tracking-[0.12em]" data-id="element-101" data-mp="25rnjh0sl8ott">
                Money-Back
                <br data-id="element-102" data-mp="20r9btjuwfgwb" />
                Guarantee
              </span>
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-103" data-mp="1vu1124c2yf53">
            <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold-deep md:text-[13px]" data-id="element-104" data-mp="1rsnrbj5v9rsw">
              Your Purchase Is Protected
            </p>
            <h2 className="mt-3 font-display text-[1.85rem] font-extrabold leading-[1.12] tracking-tight text-ink md:text-[2.4rem]" data-id="element-105" data-mp="2jjbqwqrw6p4g">
              Try WHY WE BELIEVE Risk-Free for 7 Days.
            </h2>
            <div className="mt-4 space-y-3 leading-relaxed text-ink-soft" data-id="element-106" data-mp="2ar9ur4ouvuzz">
              <p className="font-semibold text-ink" data-id="element-107" data-mp="2aoxdktqx9onz">Your purchase is protected by our 7-Day Money-Back Guarantee.</p>
              <p data-id="element-108" data-mp="32i7nu9v4xhlz">Explore the lessons, discover the resources, and see whether the collection is right for your family.</p>
              <p data-id="element-109" data-mp="10kdw4als5zgp">
                If you're not satisfied, contact our support team within 7 days of your purchase to request a refund.
              </p>
            </div>
            <div className="mt-7 max-w-md md:max-w-sm mx-auto md:mx-0" data-id="element-110" data-mp="quud94y2i5lu">
              <PurchaseButton label={`Get Instant Access for Just ${offer.price}`} data-id="element-111" data-mp="qukn9hd0vyg5" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}